import { formatThousandUnitDefaultTwo, keepTwoOrLine, keepZeroOrLine } from '@/utils/utils';
import water_pie from '../../../../imgs/water_pie.png';
import circle_spin from '../../../../imgs/circle_spin.png';

export const getChartOption = (pieLegendData?: any[]) => {
  return {
    color: ['#FF4D4F', '#FFCB47', '#2D8DFF', '#16DD8E', '#ABD335'],
    legend: {
      show: false,
    },
    tooltip: {
      trigger: 'item',
      formatter: (params: any) => {
        const { data } = params;
        return `
      <div>
        <div>${data?.name}：${formatThousandUnitDefaultTwo(data?.value)}元</div>
        <div>占比：${keepTwoOrLine(data?.rate)}%</div>
      </div>
    `;
      },
    },
    graphic: {
      elements: [
        {
          type: 'image',
          style: {
            image: water_pie,
            x: 70,
            y: 54,
            width: 68,
            height: 68,
          },
        },
        {
          type: 'image',
          style: {
            image: circle_spin,
            x: 60,
            y: 40,
            width: 90,
            height: 90,
          },
          keyframeAnimation: [
            {
              // 动画时长，单位 ms
              duration: 50000,
              // 设置旋转动画是否循环
              loop: true,
              easing: 'linear',
              // 动画的关键帧
              keyframes: [
                {
                  // percent为关键帧的位置,0为第一个,1为最后一个
                  percent: 0,
                  rotation: 0,
                  transition: ['rotation'],
                },
                {
                  percent: 1,
                  rotation: 360,
                  transition: ['rotation'],
                },
              ],
            },
          ],
          // 旋转的中心点
          origin: [105, 85],
          tooltip: {
            show: false,
          },
        },
      ],
    },
    series: [
      {
        type: 'pie',
        name: `总计`,
        percentPrecision: 5,
        minAngle: 2,
        padAngle: 1,
        radius: [52, 60],
        left: 72,
        top: 52,
        width: 66,
        height: 66,
        label: {
          show: false,
        },
        data: pieLegendData,
        showEmptyCircle: false,
      },
      {
        showEmptyCircle: false,
        data: pieLegendData,
        type: 'pie',
        percentPrecision: 5,
        padAngle: 1,
        minAngle: 2,
        left: 72,
        top: 52,
        name: `总计`,
        radius: [60, 76],
        width: 66,
        height: 66,
        emphasis: {
          disabled: true,
        },
        label: {
          show: false,
        },
        itemStyle: {
          opacity: 0.2,
        },
      },
    ],
  };
};
